import React, { useState } from 'react';
import { IconButton, TextField } from '@mui/material';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import { SketchPicker, ColorResult } from 'react-color';
import { Controller, Control } from 'react-hook-form';

interface ColorPickerProps {
    name: string;
    control: Control<any>;
    label: string;
    isInlineCss?:boolean
}

const ColorPicker: React.FC<ColorPickerProps> = ({ name, control, label ,isInlineCss}) => {
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [color, setColor] = useState('');

    const handleColorChange = (newColor: ColorResult, onChange: (value: string) => void) => {
        setColor(newColor.hex);
        onChange(newColor.hex);
    };

    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker);
    };

    const handleClose = () => {
        setDisplayColorPicker(false);
    };

    return (
        <div style={{ position: 'relative', display: 'flex' }}>
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <>
                        <TextField
                            {...field}
                            size="small"
                            fullWidth
                            className="mb-3"
                            label={label}
                            variant="outlined"
                            value={field.value || ''} // Ensure the value is correctly set
                            onChange={(e) => {
                                const value = e.target.value;
                                setColor(value);
                                field.onChange(value);
                            }}
                            InputProps={{
                                endAdornment: (
                                    <IconButton onClick={handleClick} edge="end">
                                        <Brightness1Icon style={{ color: field.value }} />
                                    </IconButton>
                                ),
                            }}
                        />
                        {displayColorPicker && (
                            <div
                                style={{
                                    position: 'absolute',
                                    zIndex: 99999999,
                                    right: '-225px',
                                    // top: '-60px',
                                    ...(isInlineCss
                                        ? { top: '-60px' }
                                        : { top: '0px' })
                                }}
                            >
                               <div
                                    style={{
                                        position: 'fixed',
                                        top: '0px',
                                        right: '0px',
                                        bottom: '0px',
                                        left: '0px',
                                    }}
                                    onClick={handleClose}
                                />
                                <SketchPicker
                                    color={color}
                                    onChange={(newColor) => handleColorChange(newColor, field.onChange)}
                                />
                            </div>
                        )}
                    </>
                )}
            />
        </div>
    );
};

export default ColorPicker;
